import moment from 'moment'

export const renderDateTimeValueCell = (value: string | null | undefined, format: string) => {
  if (!value) {
    return ''
  }

  return moment(value).format(format)
}
